// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","2808":"f34e0124","4715":"f8aecde9","7512":"c0be9443","7569":"9b0cb96b","8245":"1b5271a8","8371":"f8aecde9","8719":"1b5271a8","8887":"63d5b3e6"}[chunkId] + ".chunk.css";
};